// Single source of truth for the Google Maps browser API key.
//
// Every Google Maps call in this app (the Maps JavaScript API via
// google-map-react's `bootstrapURLKeys`, and the Static Maps images embedded in
// permit PDFs) must use this constant.
//
// Why this exists: these apps previously scattered five different keys across
// pages, and several dashboards had their key commented out entirely. When
// google-map-react is rendered without `bootstrapURLKeys` it does NOT reuse the
// already-loaded API -- it builds its loader options with
// `Object.assign({}, apiKey && {key}, bootstrapURLKeys)`, which is always a
// truthy object, so it loads the Maps script with an EMPTY key. That is what
// produced "This page didn't load Google Maps correctly."
//
// This key is enabled for both the Maps JavaScript API and the Static Maps API
// and has active billing.
export const MAPS_KEY = 'AIzaSyAeAfmgo7xdfzaH0ElTTslr65JC-PzxLk0';

export default MAPS_KEY;
